import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Images } from '../../../@resources/img';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Client, Communicator } from '../../../concepts/objects';
import { usePermissionCheck } from '../../common/PermissionElements';
import { useResolve } from '../../Container';
import { sendAlert } from '../../packages/alerts/AlertCommands';
import { ProfileModel } from '../../ProfileModel';
import { Colors } from './../../../ui';
import { withXmas } from './WithXmas';
import { XmasSnowfall } from './XmasSnowfall';

const Frame = styled.div`

    pointer-events: none;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    position: absolute;
    height: 6rem;
    bottom: 0;
    left: 0;
    right: 0;

    & > img {
        position: relative;
        flex: 0 0 auto;
    }

    #xmasSnow1, #xmasSnow5 {
        height: 6rem;
    }

    #xmasSnow2, #xmasSnow3, #xmasSnow4 {
        width: 22.5rem;
    }

    #xmasSnowman {
        position: absolute;
        right: 5.25rem;
        bottom: 4rem;
        width: 4rem;
    }

    #xmasSnowHaze {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(59,101,239,0.3) 100%);
    }

    @media only screen and (max-width: 1500px) {
        #xmasSnow2, #xmasSnow4 {
            display: none;
        }
    }

    @media only screen and (max-width: 900px) {
        #xmasSnow3, #xmasSnow3 {
            display: none;
        }
    }

    @media only screen and (max-width: 700px) {
        display: none;
    }
`;

const BellyButton = styled.div<{ enabled: boolean }>`
    position: absolute;
    bottom: 1.3rem;
    right: 5.25rem;
    width: 3rem;
    height: 3rem;
    z-index: 100;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%), 0 0 0 1px rgb(0 0 0 / 5%);
    
    ${p => p.enabled ? css`
        pointer-events: all !important;

        &:hover {
            background: ${Colors.hover};
        }

        &:active {
            background: ${Colors.active};
        }
    ` : ''}
`;


export const XmasSnow = withXmas(() => {

    const dispatch = useResolve(CommandDispatcher);
    const comms = useResolve(Communicator);
    const profile = useResolve(ProfileModel);

    const enableSnowman = usePermissionCheck('bo:write');
    const [snowing, setSnowing] = useState(false);
    const onClickSnowman = useCallback(() => {
        if (snowing) {
            setSnowing(false);
            dispatch(sendAlert, [`${profile.shortName} turned off the snow... :(`]);
            comms.send('snow', false);
        }
        else {
            setSnowing(true);
            dispatch(sendAlert, [`${profile.shortName} made it snow!`]);
            comms.send('snow', true);
        }
    }, [snowing]);

    useEffect(() => comms.recv('snow', (_sender: Client, show: boolean) => setSnowing(show)), []);


    return <Frame>
        <div id="xmasSnowHaze"></div>
        <img id="xmasSnow1" src={Images.XmasSnow1} />
        <img id="xmasSnow2" src={Images.XmasSnow2} />
        <img id="xmasSnow3" src={Images.XmasSnow3} />
        <img id="xmasSnow4" src={Images.XmasSnow4} />
        <img id="xmasSnow5" src={Images.XmasSnow5} />
        <img id="xmasSnowman" src={Images.XmasSnowman} />
        <BellyButton enabled={enableSnowman} onClick={onClickSnowman} />
        {snowing && <XmasSnowfall />}
    </Frame>;
});

